import styled from 'styled-components';
import {defaultTheme} from "../../styles/themes/default";

export const StepperContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export type StepStatus =
    'done' |
    'pending' |
    'active'

interface StepProps {
    status: StepStatus
}

const stylesForStepStatus = (status: StepStatus) => {
    switch (status) {
        case "done":
            return {
                color: defaultTheme.gray,
                background: defaultTheme.white,
                border: `2px solid ${defaultTheme.grayDivider}`
            }
        case "active":
            return {
                color: defaultTheme.white,
                background: defaultTheme.accent,
                border: 'unset'
            }
        case "pending":
            return {
                color: defaultTheme.gray,
                background: defaultTheme.grayDividerGraph,
                border: 'unset'
            }
        default:
            return {
                color: defaultTheme.gray,
                background: defaultTheme.grayDividerGraph,
                border: 'unset'
            }
    }
}

export const Step = styled.div<StepProps>`
  display: flex;
  align-items: center;
  justify-content: center;

  padding: 10px 10px;
  background: ${({status}) => stylesForStepStatus(status).background};
  color: ${({status}) => stylesForStepStatus(status).color};
  border: ${({status}) => stylesForStepStatus(status).border};
  border-radius: 8px;

  text-align: center;

  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  white-space: normal;
`;

export const Connector = styled.div`
  flex-grow: 1;
  height: 2px;
  background-color: ${({theme}) => theme.grayDividerGraph};
`;

